import { IBrandVenueAccess, VenueAccessMode } from 'src/types';

// Sentence-cased for inline use, e.g. "Brand 1 — all venues" in the summary.
export const venueAccessChoiceLabel = (entry?: IBrandVenueAccess): string => {
  if (!entry) return 'choose venue access';
  if (entry.access === 'full') return 'all venues';
  if (entry.access === 'none') return 'no venues';
  const count = entry.venue_ids?.length ?? 0;
  if (count === 0) return 'choose venues';
  return count === 1 ? '1 venue' : `${count} venues`;
};

// Capitalised for standalone use, e.g. the brand card's status badge.
export const venueAccessStatusLabel = (entry?: IBrandVenueAccess): string => {
  const label = venueAccessChoiceLabel(entry);
  return label.charAt(0).toUpperCase() + label.slice(1);
};

// Venue creation requires full venue access on the target brand, so a role that
// grants it is still refused where the user is restricted. Advisory only,
// since the combination stays valid because venue access is chosen per brand.
const BLOCKER_PHRASES: Partial<Record<VenueAccessMode, string>> = {
  specific: 'with specific venues only',
  none: 'with no venue access',
};

export const venueCreateBlockedNote = (
  entry: IBrandVenueAccess | undefined,
  roleCanCreateVenues: boolean,
): string | null => {
  const phrase = entry && roleCanCreateVenues ? BLOCKER_PHRASES[entry.access] : undefined;
  if (!phrase) return null;

  return `This user's role can create venues, but ${phrase} they won't be able to create venues in this brand. To allow it, choose all venues.`;
};
